import React from 'react';

type HeadingVariant = 'h1' | 'h2' | 'h3';

const VARIANT_CLASSES: Record<HeadingVariant, string> = {
  h1: 'font-h-1',
  h2: 'font-h-2',
  h3: 'font-h-3',
};

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  variant?: HeadingVariant;
  customClass?: string;
  children?: React.ReactNode;
  'data-testid'?: string;
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  (
    {
      variant = 'h2',
      customClass = '',
      children,
      'data-testid': dataTestId = 'heading',
      ...rest
    },
    ref
  ) => {
    const Tag: HeadingVariant = VARIANT_CLASSES[variant] ? variant : 'h2';
    const headingClass = `${
      VARIANT_CLASSES[Tag] ?? ''
    } text-navy-800 font-family ${customClass}`;

    return (
      <Tag
        ref={ref}
        className={headingClass}
        data-testid={dataTestId}
        {...rest}
      >
        {children}
      </Tag>
    );
  }
);

export default Heading;
